var isValid = function isValid(value) {
  return value !== undefined && value !== null && value !== '';
};
export default isValid;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/_util/isValid.js
// module id = null
// module chunks = 